// ⚙️ 자동 생성: 시그헌터 빙고 이미지 풀 (수동 숫자만 사용)
// scripts/generateSigHunterImagePresets.js 에 의해 생성됨
// 수동 숫자: scripts/sigHunterManualCounts.js 참고
export const sigHunterImagePresets = {
  "muse": {
    "group01": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1002.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1002
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1003.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1003
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1004.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1004
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1005.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1005
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1006.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1006
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1007.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1007
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1008.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1008
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1009.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1009
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1010.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1010
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1011.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1011
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1012.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1012
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1013.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1013
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1014.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1014
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1015.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1015
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1016.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1016
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1017.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1017
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1018.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1018
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1019.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1019
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1020.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1020
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1021.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1021
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1022.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1022
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1023.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1023
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1024.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1024
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1025.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1025
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1026.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1026
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1027.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1027
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1028.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1028
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1029.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1029
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1030.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1030
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1031.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1031
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1032.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1032
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1033.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1033
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1034.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1034
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1035.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1035
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1036.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1036
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1037.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1037
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1038.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1038
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1039.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1039
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1040.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1040
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1041.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1041
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1042.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1042
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1043.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1043
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1044.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1044
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1045.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1045
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1046.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1046
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1047.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1047
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1048.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1048
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1049.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1049
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1050.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1050
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1051.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1051
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1052.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1052
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1053.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1053
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1054.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1054
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1055.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1055
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1056.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1056
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1057.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1057
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1058.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1058
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1059.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1059
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1060.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1060
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1061.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1061
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1062.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1062
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1063.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1063
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1064.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1064
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1065.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1065
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1066.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1066
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1067.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1067
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1068.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1068
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1069.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1069
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1070.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1070
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1071.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1071
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1072.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1072
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1073.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1073
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1074.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1074
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1075.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1075
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1076.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1076
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1077.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1077
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1078.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1078
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1079.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1079
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1080.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1080
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1081.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1081
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1082.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1082
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1083.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1083
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1084.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1084
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1085.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1085
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1086.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1086
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1087.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1087
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1088.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1088
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1089.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1089
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1090.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1090
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1091.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1091
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1092.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1092
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1093.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1093
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1094.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1094
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1095.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1095
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1096.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1096
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1097.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1097
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1098.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1098
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1099.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1099
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup01%2F1100.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1100
      }
    ],
    "group02": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1102.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1102
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1103.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1103
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1104.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1104
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1105.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1105
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1106.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1106
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1107.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1107
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1108.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1108
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1109.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1109
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1110.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1110
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1111.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1111
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1112.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1112
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1115.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1115
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1117.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1117
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1118.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1118
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1119.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1119
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1120.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1120
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1121.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1121
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1122.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1122
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1123.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1123
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1124.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1124
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1125.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1125
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1126.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1126
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1127.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1127
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1133.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1133
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1140.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1140
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1142.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1142
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1144.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1144
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1145.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1145
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1233.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1233
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1234.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1234
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1250.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1250
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup02%2F1273.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1273
      }
    ],
    "group03": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1300.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1300
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1301.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1301
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1333.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1333
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1400.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1400
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1414.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1414
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1456.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1456
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1500.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1500
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1515.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1515
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1520.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1520
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1600.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1600
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1656.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1656
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1818.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1818
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup03%2F1921.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1921
      }
    ],
    "group05": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup05%2F5000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup05%2F5001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup05%2F6000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 6000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup05%2F7777.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7777
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup05%2F7788.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7788
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup05%2F8888.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 8888
      }
    ],
    "group06": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10042.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10043.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10043
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10057.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10057
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10072.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10072
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10077.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10077
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10078.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10083.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10083
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10084.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10084
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10089.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10111.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10111
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10133.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10133
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10135.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10135
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10142.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10142
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10145.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10145
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10152.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10152
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10164.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10164
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10187.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10188.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10188
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup06%2F10272.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10272
      }
    ],
    "group07": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F10000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F10042.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F10078.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F10145.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F10187.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F5000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F5001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F6000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 6000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F7777.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7777
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F7788.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7788
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fmuse%2Fgroup07%2F8888.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 8888
      }
    ],
    "group08": []
  },
  "queendom": {
    "group01": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1002.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1002
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1003.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1003
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1004.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1004
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1005.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1005
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1006.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1006
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1007.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1007
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1008.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1008
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1009.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1009
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1010.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1010
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1011.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1011
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1012.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1012
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1013.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1013
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1014.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1014
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1015.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1015
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1016.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1016
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1017.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1017
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1018.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1018
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1019.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1019
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1020.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1020
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1021.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1021
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1022.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1022
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1023.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1023
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1024.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1024
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1025.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1025
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1026.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1026
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1027.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1027
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1028.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1028
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1029.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1029
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1030.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1030
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1031.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1031
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1032.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1032
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1033.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1033
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1034.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1034
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1035.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1035
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1036.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1036
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1037.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1037
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1038.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1038
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1039.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1039
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1040.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1040
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1041.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1041
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1042.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1042
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1043.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1043
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1044.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1044
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1045.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1045
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1046.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1046
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1047.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1047
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1048.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1048
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1049.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1049
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1050.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1050
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1051.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1051
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1052.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1052
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1053.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1053
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1054.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1054
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1055.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1055
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1056.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1056
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1057.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1057
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1058.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1058
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1059.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1059
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1060.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1060
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1061.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1061
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1062.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1062
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1063.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1063
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1064.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1064
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1065.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1065
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1066.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1066
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1067.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1067
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1068.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1068
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1069.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1069
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1070.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1070
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1071.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1071
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1072.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1072
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1073.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1073
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1074.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1074
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1075.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1075
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1076.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1076
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1077.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1077
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1078.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1078
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1079.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1079
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1080.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1080
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1081.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1081
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1082.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1082
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1083.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1083
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1084.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1084
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1085.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1085
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1086.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1086
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1087.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1087
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1088.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1088
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1089.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1089
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1090.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1090
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1091.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1091
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1092.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1092
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1093.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1093
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1094.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1094
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1095.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1095
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1096.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1096
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1097.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1097
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1098.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1098
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1099.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1099
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup01%2F1100.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1100
      }
    ],
    "group02": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1101.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1101
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1102.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1102
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1103.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1103
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1104.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1104
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1105.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1105
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1106.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1106
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1107.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1107
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1108.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1108
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1109.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1109
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1110.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1110
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1111.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1111
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1112.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1112
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1113.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1113
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1114.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1114
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1115.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1115
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1117.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1117
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1118.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1118
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1119.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1119
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1120.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1120
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1121.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1121
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1122.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1122
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1123.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1123
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1124.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1124
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1125.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1125
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1126.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1126
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1128.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1128
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1131.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1131
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1132.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1132
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1133.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1133
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1135.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1135
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1140.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1140
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1158.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1158
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1160.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1160
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1170.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1170
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1180.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1180
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1200.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1200
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1234.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1234
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1235.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1235
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1250.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1250
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup02%2F1270.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1270
      }
    ],
    "group03": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1300.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1300
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1345.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1345
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1350.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1350
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1400.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1400
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1450.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1450
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1500.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1500
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1501.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1501
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1515.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1515
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1520.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1520
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1560.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1560
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1577.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1577
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1777.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1777
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1800.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1800
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1818.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1818
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1900.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1900
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup03%2F1999.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1999
      }
    ],
    "group05": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F5000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F5002.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5002
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F6000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 6000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F6666.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 6666
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F7000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F7007.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7007
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F7700.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7700
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F7777.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7777
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F7788.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7788
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F8282.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 8282
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup05%2F9000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 9000
      }
    ],
    "group06": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10002.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10002
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10003.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10003
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10005.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10005
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10007.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10007
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10008.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10008
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10009.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10009
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10010.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10010
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10011.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10011
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10012.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10012
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10014.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10027.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10040.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10040
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10043.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10044.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10044
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10047.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10049.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10049
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10057.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10058.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10058
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10065.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10071.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10071
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10072.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10073.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10073
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10083.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10092.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10092
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10093.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10126.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10126
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10155.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10162.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10162
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10167.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10167
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10178.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10178
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10365.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10365
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10482.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10482
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10532.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10532
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F10555.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10555
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F12486.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 12486
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup06%2F12487.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 12487
      }
    ],
    "group07": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10004.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10018.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10025.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10026.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10030.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10031.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10032.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10034.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10042.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10047.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10052.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10063.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10069.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10072.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10074.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10075.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10084.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10085.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10097.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10098.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10099.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10100.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10101.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10113.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10114.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10115.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10118.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10121.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10129.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10154.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10163.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10177.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10182.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10184.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10192.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10199.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10202.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10224.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10242.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10278.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10292.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10314.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10315.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10332.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10333.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10401.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10444.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10445.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10455.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10486.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10545.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10765.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F10972.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F11111.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F11818.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F12337.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F12412.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F12445.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F12576.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F15787.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F15914.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F18620.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F20012.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup07%2F54321.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      }
    ],
    "group08": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10002.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10002
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10003.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10003
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10005.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10005
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10007.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10007
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10008.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10008
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10009.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10009
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10010.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10010
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10012.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10012
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10026.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10045.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F10071.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F12486.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 12486
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F12487.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 12487
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F5000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F5001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F5002.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5002
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F6000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 6000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F6666.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 6666
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F7000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F7007.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7007
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F7700.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7700
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F7777.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7777
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F7788.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7788
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F8282.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 8282
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fqueendom%2Fgroup08%2F9000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 9000
      }
    ]
  },
  "holic": {
    "group01": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1002.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1002
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1003.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1003
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1004.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1004
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1005.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1005
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1006.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1006
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1007.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1007
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1008.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1008
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1009.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1009
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1010.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1010
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1011.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1011
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1012.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1012
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1014.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1014
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1015.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1015
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1016.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1016
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1017.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1017
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1018.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1018
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1019.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1019
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1020.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1020
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1021.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1021
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1022.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1022
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1023.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1023
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1024.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1024
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1025.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1025
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1026.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1026
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1027.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1027
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1028.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1028
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1029.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1029
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1030.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1030
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1031.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1031
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1032.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1032
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1033.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1033
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1034.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1034
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1035.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1035
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1036.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1036
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1037.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1037
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1038.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1038
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1039.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1039
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1040.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1040
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1041.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1041
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1042.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1042
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1043.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1043
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1045.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1045
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1046.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1046
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1047.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1047
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1048.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1048
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1049.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1049
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1050.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1050
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1051.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1051
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1052.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1052
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1053.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1053
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1054.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1054
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1055.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1055
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1056.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1056
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1057.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1057
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1058.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1058
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1059.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1059
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1060.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1060
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1061.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1061
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1062.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1062
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1063.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1063
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1064.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1064
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1065.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1065
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1066.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1066
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1067.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1067
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1068.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1068
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1070.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1070
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1071.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1071
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1072.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1072
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1073.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1073
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1074.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1074
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1075.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1075
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1076.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1076
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1077.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1077
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1078.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1078
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1079.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1079
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1080.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1080
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1081.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1081
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1082.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1082
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1083.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1083
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1084.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1085.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1086.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1087.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1087
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1088.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1089.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1090.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1091.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1092.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1093.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1094.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1095.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1096.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup01%2F1100.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      }
    ],
    "group02": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1101.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1101
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1102.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1102
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1103.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1103
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1104.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1104
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1105.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1105
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1106.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1106
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1107.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1107
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1108.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1108
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1109.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1109
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1110.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1110
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1111.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1111
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1112.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1112
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup02%2F1113.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1113
      }
    ],
    "group03": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup03%2F1314.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1314
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup03%2F1500.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1500
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup03%2F1515.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1515
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup03%2F1516.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1516
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup03%2F1517.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1517
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup03%2F1520.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1520
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup03%2F1818.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 1818
      }
    ],
    "group05": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup05%2F5000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup05%2F5001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup05%2F7000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup05%2F7777.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7777
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup05%2F7788.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7788
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup05%2F8888.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 8888
      }
    ],
    "group06": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10003.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10003
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10004.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10004
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10005.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10005
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10018.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10018
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10062.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10062
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10100.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10100
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10108.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10108
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10112.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10112
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10113.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10113
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10133.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10138.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10138
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10142.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10144.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10148.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10162.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10181.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10182.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10182
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10192.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F10888.webp?alt=media",
        "rawText": "[NO_MANUAL]",
        "count": 0
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup06%2F12486.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 12486
      }
    ],
    "group07": [
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F10000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F10003.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10003
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F10004.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10004
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F10005.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10005
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F10018.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10018
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F10062.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 10062
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F12486.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 12486
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F5000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F5001.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 5001
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F7000.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7000
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F7777.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7777
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F7788.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 7788
      },
      {
        "path": "https://firebasestorage.googleapis.com/v0/b/sig-hunter.firebasestorage.app/o/images%2Fholic%2Fgroup07%2F8888.webp?alt=media",
        "rawText": "[MANUAL]",
        "count": 8888
      }
    ],
    "group08": []
  }
};
